<div>
  <app-be-input-group-reactive
    [beFormGroup]="parentForm"
    [beFormControl]="parentForm.controls['password']"
    beFormControlName="password"
    inputLabel="Password"
    inputType="password"
    inputPlaceholder="Password"
    requiredError="A password is required to create your account"
    variant="sm"
    [eevTrackingConfig]="passwordTrackingConfig"
    [errorTrackingSubject]="errorTrackingSubject"
    >
  </app-be-input-group-reactive>
  @if (parentForm.controls['password'].dirty) {
    <mat-card
      class="mat-card"
      class="password-validation-card"
      [formGroup]="parentForm"
      >
      <div class="password-validation-title">Password must:</div>
      <div
        class="password-validation-list"
      [ngClass]="
        parentForm.controls['password'].hasError('required') ||
        parentForm.controls['password'].hasError('minlength')
          ? 'text-danger'
          : 'text-success'
      "
        >
        <em class="material-icons">
          {{
          parentForm.controls['password'].hasError('required') ||
          parentForm.controls['password'].hasError('minlength')
          ? 'clear'
          : 'check'
          }}
        </em>
        Be at least 8 characters
      </div>
      <div
        class="password-validation-list"
      [ngClass]="
        parentForm.controls['password'].hasError('required') ||
        parentForm.controls['password'].hasError('hasCapitalCase')
          ? 'text-danger'
          : 'text-success'
      "
        >
        <em class="material-icons">
          {{
          parentForm.controls['password'].hasError('required') ||
          parentForm.controls['password'].hasError('hasCapitalCase')
          ? 'clear'
          : 'check'
          }}
        </em>
        Contain at least one capital letter
      </div>
      <div
        class="password-validation-list"
      [ngClass]="
        parentForm.controls['password'].hasError('required') ||
        parentForm.controls['password'].hasError('hasSmallCase')
          ? 'text-danger'
          : 'text-success'
      "
        >
        <em class="material-icons">
          {{
          parentForm.controls['password'].hasError('required') ||
          parentForm.controls['password'].hasError('hasSmallCase')
          ? 'clear'
          : 'check'
          }}
        </em>
        Contain at least one lower case letter
      </div>
      <div
        class="password-validation-list"
      [ngClass]="
        parentForm.controls['password'].hasError('required') ||
        parentForm.controls['password'].hasError('hasSpecialCharacters')
          ? 'text-danger'
          : 'text-success'
      "
        >
        <em class="material-icons">
          {{
          parentForm.controls['password'].hasError('required') ||
          parentForm.controls['password'].hasError('hasSpecialCharacters')
          ? 'clear'
          : 'check'
          }}
        </em>
        Contain at least one special character
      </div>
      <div
        class="password-validation-list"
      [ngClass]="
        parentForm.controls['password'].hasError('required') ||
        parentForm.controls['password'].hasError('hasNumeric')
          ? 'text-danger'
          : 'text-success'
      "
        >
        <em class="material-icons">
          {{
          parentForm.controls['password'].hasError('required') ||
          parentForm.controls['password'].hasError('hasNumeric')
          ? 'clear'
          : 'check'
          }}
        </em>
        Contain at least one number
      </div>
      <div
        class="password-validation-list"
      [ngClass]="
        parentForm.controls['password'].hasError('required') ||
        parentForm.controls['password'].hasError('hasWhiteSpace')
          ? 'text-danger'
          : 'text-success'
      "
        >
        <em class="material-icons">
          {{
          parentForm.controls['password'].hasError('required') ||
          parentForm.controls['password'].hasError('hasWhiteSpace')
          ? 'clear'
          : 'check'
          }}
        </em>
        Have no whitespace
      </div>
    </mat-card>
  }
  <app-be-input-group-reactive
    [beFormGroup]="parentForm"
    [beFormControl]="parentForm.controls['confirmPassword']"
    beFormControlName="confirmPassword"
    inputLabel="Re-enter password"
    inputPlaceholder="Re-enter password"
    inputType="password"
    requiredError="Please re-enter your password"
    [detailError]="confirmPasswordError"
    variant="sm"
    [eevTrackingConfig]="confirmTrackingConfig"
    [errorTrackingSubject]="errorTrackingSubject"
    >
  </app-be-input-group-reactive>
</div>
